export default __webpack_public_path__ + "static/media/botellagua.6aa44206.png";